module.exports = __webpack_public_path__ + "img/disabled-semipublic.a6d85ee1.svg";